import React from "react";
import { FaLock } from "react-icons/fa";
import "../styles/CustomTaskAttachmentSection.css";

const ReviewedTaskLockNotice = ({ className = "" }) => (
  <div
    className={`custom-task-review-notice ${className}`.trim()}
    role="status"
  >
    <span className="custom-task-review-notice-icon" aria-hidden="true">
      <FaLock />
    </span>
    <span className="custom-task-review-notice-content">
      <strong>Editing locked after review</strong>
      <span>
        This task has been reviewed. New attachments and task dates can no longer
        be changed. Users with delete permission can still remove uploaded files.
      </span>
    </span>
  </div>
);

export default ReviewedTaskLockNotice;
